enum OperatingSystem {
    ANDROID_11 = 'android_11',
    DEBIAN_11 = 'debian_11',
    LINUX_MINT_22 = 'linux_mint_22',
    ROCKY_LINUX_10 = 'rocky_linux_10',
    UBUNTU_22_04 = 'ubuntu_22_04',
    UBUNTU_24_04 = 'ubuntu_24_04',
    WINDOWS_10 = 'windows_10',
    WINDOWS_11 = 'windows_11',
    WINDOWS_SERVER_2022 = 'windows_server_2022',
    WINDOWS_SERVER_2025 = 'windows_server_2025',
}

export default OperatingSystem
